module.exports = __webpack_public_path__ + "img/logo_festival.6a1c6f44.svg";